<div class="action-current">
  <button
    mat-stroked-button
    class="history-button"
    [color]="activeSnapshot === null ? 'primary' : ''"
    (click)="setCurrent()"
  >
    {{ i18n.get('currentState') }}
  </button>
  @for (changeset of currentChangesets; track $index) {
    <ng-container [ngTemplateOutlet]="changesetInfos" [ngTemplateOutletContext]="{ changeset, element: null }">
    </ng-container>
  }
</div>

@if (snapshots(); as snapshots) {
  <table mat-table [dataSource]="snapshots.data" class="mat-elevation-z8">
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef>{{ i18n.get('snapshotTimestamp') }}</th>
      <td mat-cell *matCellDef="let element" aria-role="button" class="history-element">
        <button
          mat-stroked-button
          class="history-button"
          [color]="activeSnapshot === element.documentId ? 'primary' : ''"
          (click)="setHistory(element)"
        >
          {{ element.createdAt | date: 'dd.MM.yyyy HH:mm:ss' }}
        </button>
        @for (changeset of element.changesets; track $index) {
          <ng-container [ngTemplateOutlet]="changesetInfos" [ngTemplateOutletContext]="{ changeset, element }">
          </ng-container>
        }
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="['createdAt']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['createdAt']"></tr>
    <tr class="mat-mdc-row" *matNoDataRow>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ i18n.get('noSnapshots') }}</td>
    </tr>
  </table>
}
<mat-paginator [length]="resultSize" [pageSize]="20" aria-label="Select page of Snapshot search result"></mat-paginator>

<ng-template #changesetInfos let-changeset="changeset" let-element="element">
  <div class="changeset">
    <div class="changeset-descriptions">
      @for (line of changeset.description; track $index) {
        @if (line.startsWith('add')) {
          <div class="changeset-description"><mat-icon title="add">add</mat-icon>{{ line.substring(3) }}</div>
        } @else if (line.startsWith('remove')) {
          <div class="changeset-description">
            <mat-icon title="remove" class="remove">close</mat-icon>{{ line.substring(6) }}
          </div>
        } @else if (line.startsWith('update')) {
          <div class="changeset-description"><mat-icon title="update">sync</mat-icon>{{ line.substring(6) }}</div>
        } @else {
          <div class="changeset-description">{{ line }}</div>
        }
      }
    </div>
    <button
      class="button"
      mat-icon-button
      (click)="highlightChangedElements(changeset)"
      [color]="highlightedChangeset === changeset.id ? 'primary' : ''"
    >
      <mat-icon>my_location</mat-icon>
    </button>
    @if (expertView) {
      <button
        class="button"
        mat-icon-button
        (click)="showDetails(changeset)"
        [color]="activeChangeset === changeset.id ? 'primary' : ''"
      >
        <mat-icon>list</mat-icon>
      </button>
    }
  </div>
  @if (expertView && activeChangeset === changeset.id) {
    <app-change-detail [changeset]="changeset" [snapshotId]="element?.documentId"></app-change-detail>
  }
</ng-template>
